import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DataListingProviderComponent } from '../../../../shared/components/data-listing-provider/data-listing-provider.component';
import { AuthenticationGuard } from '../../../../shared/guard/authentication-guard';
import { HasUnsavedChangesGuard } from '../../../../shared/guard/has-form-changed.guard';
import { Entity, HeaderMenuType } from '../../../../shared/store/view/types';
import { ModuleId } from '../../../../shared/store/navigation/types';
import { WorkScheduleDetailsComponent } from './work-schedule-details/work-schedule-details.component';
import { WorkScheduleEditComponent } from './work-schedule-edit/work-schedule-edit.component';
import { WorkScheduleCreateComponent } from './work-schedule-create/work-schedule-create.component';

const routes: Routes = [
  {
    path: 'Configuration/WorkSchedules',
    data: {
      breadcrumb: { label: ' ', alias: 'list' },
    },
    children: [
      {
        path: '',
        redirectTo: 'List',
        pathMatch: 'full',
      },
      {
        path: 'List',
        component: DataListingProviderComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkSchedule,
          breadcrumb: { skip: true },
        },
      },
      {
        path: 'Details/:id',
        component: WorkScheduleDetailsComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkSchedule,
          breadcrumb: { label: ' ', alias: 'workScheduleDetails' },
        },
      },
      {
        path: 'Edit/:id',
        component: WorkScheduleEditComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkSchedule,
          breadcrumb: { label: ' ', alias: 'workScheduleEdit' },
        },
      },
      {
        path: 'Create',
        component: WorkScheduleCreateComponent,
        canActivate: [AuthenticationGuard],
        canDeactivate: [HasUnsavedChangesGuard],
        data: {
          headerMenu: HeaderMenuType.Configuration,
          moduleId: ModuleId.configuration,
          entity: Entity.WorkSchedule,
          breadcrumb: { label: ' ', alias: 'workScheduleCreate' },
        },
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WorkScheduleRoutingModule {}
